var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditSecondaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 2.60114H4.83325C3.43312 2.60114 2.73305 2.60114 2.19828 2.87363C1.72787 3.11331 1.34542 3.49576 1.10574 3.96617C0.833252 4.50094 0.833252 5.20101 0.833252 6.60114V13.6011C0.833252 15.0013 0.833252 15.7013 1.10574 16.2361C1.34542 16.7065 1.72787 17.089 2.19828 17.3287C2.73305 17.6011 3.43312 17.6011 4.83325 17.6011H11.8333C13.2334 17.6011 13.9334 17.6011 14.4682 17.3287C14.9386 17.089 15.3211 16.7065 15.5608 16.2361C15.8333 15.7013 15.8333 15.0013 15.8333 13.6011V10.1011M5.83323 12.6011H7.22868C7.63633 12.6011 7.84016 12.6011 8.03197 12.5551C8.20203 12.5143 8.36461 12.4469 8.51373 12.3555C8.68192 12.2525 8.82605 12.1083 9.1143 11.8201L17.0833 3.85114C17.7736 3.16079 17.7736 2.0415 17.0833 1.35114C16.3929 0.660786 15.2736 0.660785 14.5833 1.35114L6.61428 9.32009C6.32603 9.60835 6.1819 9.75247 6.07883 9.92067C5.98745 10.0698 5.92011 10.2324 5.87928 10.4024C5.83323 10.5942 5.83323 10.7981 5.83323 11.2057V12.6011Z",
    stroke: "#3F4684",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSecondaryIcon);
export default __webpack_public_path__ + "static/media/edit-secondary-icon.77e2ca5b50677a7c9b6d81d3594ea37b.svg";
export { ForwardRef as ReactComponent };